import type { Action } from 'ext/lib/collections';
import { FETCH_TACTICS, RESOLVE_TACTICS, REJECT_TACTICS } from './actions';
import type { TacticGroup, TacticsState } from './types';

const defaultState: TacticsState = { groups: [], status: 'idle' };

export default function tactics(
  state: TacticsState = defaultState,
  action: Action
): TacticsState {
  switch (action.type) {
    case FETCH_TACTICS:
      return { ...state, status: 'loading' };
    case RESOLVE_TACTICS:
      return { groups: action.payload as TacticGroup[], status: 'loaded' };
    case REJECT_TACTICS:
      return { ...state, status: 'error' };
    default:
      return state;
  }
}

export const selectTacticGroups = <T extends { tactics: TacticsState }>(
  state: T
): TacticGroup[] => state.tactics.groups;

export const selectTacticsStatus = <T extends { tactics: TacticsState }>(
  state: T
): TacticsState['status'] => state.tactics.status;
